function getV3Authorizer(backendService, params) {
  return {
    getToken: async () => {
      const {
        data: { authorization, refreshToken }
      } = await backendService.entitlement.v3.getTokenAuthorizer({
        delay: params.getDelay?.() || 0,
        mobileNetwork: params.getIsMobileNetwork?.() || false,
        isLive: params.isLive,
        contentId: params.contentId
      });
      return { data: { accessToken: authorization, refreshToken } };
    },
    refreshToken: ({ refreshToken }) => backendService.entitlement.v3.refreshTokenAuthorizer({
      delay: params.getDelay?.() || 0,
      mobileNetwork: params.getIsMobileNetwork?.() || false,
      refreshToken
    })
  };
}

export { getV3Authorizer };
//# sourceMappingURL=authorizer.js.map
